<template>
    <div v-visible="handleTitleShowChange" :id="domId" class="titleBox">
        <div class="contentTitle">
            {{ title }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        domId: {
            type: String,
            default: '',
        }
    },
    data() {
        return {

        }
    },
    created() {

    },
    methods: {
        handleTitleShowChange(isVisible) {
            if (isVisible) {
                // console.error(this.domId)
                this.$emit('titleShowChange', this.domId)
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.titleBox {
    width: 1200px;
    margin: auto;
    padding-top: 57px;
    margin-bottom: 48px;

    .contentTitle {
        font-weight: bold;
        font-size: 40px;
        color: #000000;
        line-height: 50px;
        padding-bottom: 16px;
        border-bottom: 1px solid #000000;
    }
}

@media screen and (max-width:1200px) {
    .titleBox {
        width: 100%;
        margin: auto;
        margin-top: 50px;

        .contentTitle {
            font-weight: bold;
            font-size: 24px;
            color: #000000;
            line-height: 30px;
            padding-bottom: 16px;
            border-bottom: 1px solid #000000;
        }
    }
}
</style>